var _circle, _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeAvatar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5254 18.691C19.5254 15.8338 21.8416 13.5176 24.6988 13.5176H45.3923C48.2495 13.5176 50.5657 15.8338 50.5657 18.691V49.7312C51.9943 49.7312 53.1524 50.8893 53.1524 52.3179C53.1524 53.7465 51.9943 54.9046 50.5657 54.9046H42.3745C41.184 54.9046 40.2189 53.9395 40.2189 52.749V47.1445C40.2189 45.7159 39.0608 44.5578 37.6322 44.5578H32.4589C31.0303 44.5578 29.8722 45.7159 29.8722 47.1445V52.749C29.8722 53.9395 28.9071 54.9046 27.7166 54.9046H19.5254C18.0968 54.9046 16.9387 53.7465 16.9387 52.3179C16.9387 50.8893 18.0968 49.7312 19.5254 49.7312V18.691ZM27.2855 21.2776H32.4589V26.451H27.2855V21.2776ZM32.4589 31.6244H27.2855V36.7978H32.4589V31.6244ZM37.6322 21.2776H42.8056V26.451H37.6322V21.2776ZM42.8056 31.6244H37.6322V36.7978H42.8056V31.6244Z",
    fill: "#307F92"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.7014,
    y: 20.8604,
    width: 5.84091,
    height: 5.84091,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5486,
    y: 20.8604,
    width: 5.84091,
    height: 5.84091,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5486,
    y: 31.2905,
    width: 5.84091,
    height: 5.84091,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7014,
    y: 31.2905,
    width: 5.84091,
    height: 5.84091,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar2);
export default __webpack_public_path__ + "static/media/Office-Avatar-2.142ff4f26433be6764e940d0cef8051e.svg";
export { ForwardRef as ReactComponent };